import { useStateXAtomValue } from '@cloudio-saas/statex';
import { useEffect, useRef } from 'react';
import { ITriggerProps } from '../../componentregistry';
import { getScreenSize } from '../../hooks/useScreenSize';
import { rootPageWidthAtom, windowSizeAtom } from '../../hooks/useWindowSize';
import useTrigger from '../../triggers/useTrigger';

export function useResponsiveTriggers({
  platform,
  roleUid,
  appUid,
  pageId,
  itemId,
}: Omit<ITriggerProps, 'triggerItemId'>) {
  const [onSmallScreenTrigger] = useTrigger(
    {
      platform,
      roleUid,
      appUid,
      pageId,
      itemId,
      disableProgressTracking: true,
    },
    'TriggerOnSmallScreen',
  );
  const [onMediumScreenTrigger] = useTrigger(
    {
      platform,
      roleUid,
      appUid,
      pageId,
      itemId,
      disableProgressTracking: true,
    },
    'TriggerOnMediumScreen',
  );
  const [onLargeScreenTrigger] = useTrigger(
    {
      platform,
      roleUid,
      appUid,
      pageId,
      itemId,
      disableProgressTracking: true,
    },
    'TriggerOnLargeScreen',
  );
  const [onExtraLargeScreenTrigger] = useTrigger(
    {
      platform,
      roleUid,
      appUid,
      pageId,
      itemId,
      disableProgressTracking: true,
    },
    'TriggerOnExtraLargeScreen',
  );
  const [onExtraSmallScreenTrigger] = useTrigger(
    {
      platform,
      roleUid,
      appUid,
      pageId,
      itemId,
      disableProgressTracking: true,
    },
    'TriggerOnExtraSmallScreen',
  );
  const [onLandscapeScreenTrigger] = useTrigger(
    {
      platform,
      roleUid,
      appUid,
      pageId,
      itemId,
      disableProgressTracking: true,
    },
    'TriggerOnLandscapeScreen',
  );
  const [onPortraitScreenTrigger] = useTrigger(
    {
      platform,
      roleUid,
      appUid,
      pageId,
      itemId,
      disableProgressTracking: true,
    },
    'TriggerOnPortraitScreen',
  );
  const [onWindowSizeChangeTrigger] = useTrigger(
    {
      platform,
      roleUid,
      appUid,
      pageId,
      itemId,
      disableProgressTracking: true,
    },
    'TriggerOnWindowSizeChange',
  );

  const width = useStateXAtomValue(rootPageWidthAtom);
  const { height } = useStateXAtomValue(windowSizeAtom);
  const ref = useRef({
    xs: false,
    sm: false,
    lg: false,
    xl: false,
    md: false,
    portrait: false,
    landscape: false,
    mobile: false,
    tablet: false,
    desktop: false,
  });
  useEffect(() => {
    if (width > 0 && height > 0) {
      const screenSize = getScreenSize({
        width,
        height,
      });
      const { lg, md, sm, xl, xs, landscape, portrait } = screenSize;
      if (xs && xs !== ref.current.xs) {
        onExtraSmallScreenTrigger?.();
      }
      if (sm && sm !== ref.current.sm) {
        onSmallScreenTrigger?.();
      }
      if (md && md !== ref.current.md) {
        onMediumScreenTrigger?.();
      }
      if (lg && lg !== ref.current.lg) {
        onLargeScreenTrigger?.();
      }
      if (xl && xl !== ref.current.xl) {
        onExtraLargeScreenTrigger?.();
      }
      if (portrait && portrait !== ref.current.portrait) {
        onPortraitScreenTrigger?.();
      }
      if (landscape && landscape !== ref.current.landscape) {
        onLandscapeScreenTrigger?.();
      }
      onWindowSizeChangeTrigger?.();
      ref.current = screenSize;
    }
  }, [
    height,
    onExtraLargeScreenTrigger,
    onExtraSmallScreenTrigger,
    onLandscapeScreenTrigger,
    onLargeScreenTrigger,
    onMediumScreenTrigger,
    onPortraitScreenTrigger,
    onSmallScreenTrigger,
    onWindowSizeChangeTrigger,
    width,
  ]);
}
